export default __webpack_public_path__ + "static/media/uy.2471ee7a.svg";